module.exports = __webpack_public_path__ + "img/5.ebdce791.png";